/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getContactAliasHistory} from '../api'

 export const useQueryGetContactAliasHistory = createReactQueryHook('getContactAliasHistory', getContactAliasHistory)
